export default function Footer() {
    return (
        <footer className="shrink-0 border-t border-gray-200 bg-white">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-2 px-6 py-3">

                <p className="text-xs text-muted-foreground">
                    © {new Date().getFullYear()} Leonardo Center on Business for Society. All rights reserved.
                </p>

                <p className="text-xs text-muted-foreground">
                    Need help?{' '}
                    <a
                        href="mailto:Leonardo.centre@imperial.ac.uk"
                        className="font-medium text-gray-700 hover:text-primary transition-colors hover:underline underline-offset-4"
                    >
                        Leonardo.centre@imperial.ac.uk
                    </a>
                </p>

            </div>
        </footer>
    )
}
